import { render, staticRenderFns } from "./PersonalizedGameEditorString.vue?vue&type=template&id=a5c1a724&scoped=true&"
import script from "./PersonalizedGameEditorString.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c1a724",
  null
  
)

export default component.exports